import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import * as actionTypes from '../actions/actionTypes';

const initialAuthState = {
    user: undefined,
    authToken: undefined,
    twoFactorUuid : undefined,
    avatar : undefined
};

const authReducer = persistReducer(
    { storage, key: "od-auth", whitelist: ["user", "authToken", "twoFactorUuid", "avatar"] },
    (state = initialAuthState, action) => {
        switch (action.type) {
            case actionTypes.AUTH_LOGIN: {
                const { authToken } = action.payload;

                return { authToken, user: undefined };
            }

            case actionTypes.TWO_FACTOR_UUID_REQUESTED: {
                const { twoFactorUuid } = action.payload;

                return { twoFactorUuid, authToken: undefined, user: undefined };
            }

            case actionTypes.CANCEL_TWO_FACTOR_VALIDATION: {
                return { twoFactorUuid: null, user: undefined };
            }

            case actionTypes.AUTH_LOGOUT: {
                return { authToken: undefined, user: undefined };
            }

            case actionTypes.USER_LOADED: {
                const {user, avatar} = action.payload;
                return {
                    ...state,
                    user,
                    avatar
                };
            }

            default:
                return state;
        }
    }
);

export default authReducer;
